module.exports = __webpack_public_path__ + "static/img/05016B_1_C_20210925_LC.eddfba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05016B_1_C_20210925_LC.png
// module id = MXzb
// module chunks = 0